import { GET, POST } from '@/shared/api/requests';
import type {
  MarkAllNotificationsReadResponse,
  Notification,
  PaginatedNotificationsResponse,
  UnreadNotificationCountResponse,
} from '../types';

const BASE = '/notifications/items';

export const getNotifications = async (
  page = 1,
  pageSize = 20,
): Promise<PaginatedNotificationsResponse> => {
  const params = new URLSearchParams({
    page: String(page),
    page_size: String(pageSize),
  });
  const response = await GET(`${BASE}/?${params.toString()}`);
  return response.data as PaginatedNotificationsResponse;
};

export const getRecentNotifications = async (): Promise<PaginatedNotificationsResponse> =>
  getNotifications(1, 5);

export const getUnreadNotificationCount = async (): Promise<UnreadNotificationCountResponse> => {
  const response = await GET(`${BASE}/unread-count/`);
  return response.data as UnreadNotificationCountResponse;
};

export const markNotificationRead = async (id: number): Promise<Notification> => {
  const response = await POST(`${BASE}/${id}/mark-read/`, {});
  return response.data as Notification;
};

export const markAllNotificationsRead = async (): Promise<MarkAllNotificationsReadResponse> => {
  const response = await POST(`${BASE}/mark-all-read/`, {});
  return response.data as MarkAllNotificationsReadResponse;
};
